export default __webpack_public_path__ + "static/modding_license-e8d3dcad7bba4ff84b2fdc35499d2aab.png";